<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_60_w" v-if="!loading && section && isReady">
        <v-card class="rounded_max" elevation="1" style="overflow: hidden">
          <div class="strip" :style="`background:${section.color}`"></div>
          <div class="d-flex justify-space-between px-2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                  icon
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
          </div>
          <div class="px-5 pb-5" v-if="module">
            <h3>{{ module.title }}</h3>
            <p class="caption" v-if="module.course_module">
              Due Date:
              {{
                $date(module.course_module.end_module).format(
                  "dddd, DD MMMM YYYY | HH:mm",
                )
              }}
            </p>
            <p class="mb-0 mt-2" v-html="module.description"></p>
          </div>
        </v-card>
        <v-card
          class="rounded_max mt-3 noverflow"
          elevation="1"
          v-if="answered"
        >
          <div class="pa-5 d-flex flex-column" style="width: 100%">
            <h4>Score Assignment (Max. 100)</h4>
            <v-progress-linear
              :value="answered.score"
              color="#006341"
              class="my-2"
              height="25"
              rounded
              readonly
            >
              <template v-slot:default="{ value }">
                <strong style="color: white">{{ Math.ceil(value) }}%</strong>
              </template>
            </v-progress-linear>
          </div>
        </v-card>
        <v-card
          class="rounded_max mt-3 noverflow"
          elevation="1"
          v-if="answered"
        >
          <div class="pa-5">
            <h4>Your Assignment</h4>
            <v-card class="my-2 d-flex align-center" outlined>
              <v-card
                class="d-flex align-center justify-center"
                outlined
                height="80px"
                width="80px"
              >
                <v-icon size="50">mdi-file-document</v-icon>
              </v-card>
              <div class="px-3">
                <a :href="answered.answer" target="_blank">
                  {{ answered.answer }}
                </a>
              </div>
            </v-card>

            <div class="d-flex justify-end">
              <p class="ma-0 small_txt">
                Date Modified :
                {{
                  $date(answered.updated_at).format("dddd, DD MM YYYY | HH:mm")
                }}
              </p>
            </div>
          </div>
        </v-card>
        <div class="mt-3">
          <v-card class="rounded_max pa-3" elevation="1">
            <h4 class="">{{ dataSet.content }}</h4>
            <p
              class="mb-5 text-red"
              style="font-size: 14px !important; color: #f44336"
              v-if="module.course_module"
            >
              Due Date:
              {{
                $date(module.course_module.end_module).format(
                  "dddd, DD MMMM YYYY | HH:mm",
                )
              }}
            </p>

            <v-overlay
              :absolute="true"
              color="white"
              opacity="1"
              :value="overlay"
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                :color="section.color"
              ></v-progress-circular>
              <b :style="`color:${section.color}`">uploading...</b>
            </v-overlay>

            <h4>Upload Your Assignment</h4>
            <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              :useCustomSlot="true"
              :options="dropzoneOptions"
              @vdropzone-file-added="uploadFile"
            >
              <div>
                <img
                  src="../../../../assets/img/dragCreateReport.png"
                  height="90px"
                  alt=""
                />
                <h4 class="dropzone-custom-title">click to select a file</h4>
              </div>
            </vue-dropzone>
          </v-card>
        </div>

        <v-card
          class="rounded_max mt-3 noverflow"
          elevation="1"
          v-if="answered"
        >
          <div class="pa-5 d-flex flex-column" style="width: 100%">
            <h4 class="mb-3">Notes for you</h4>
            <v-card
              class="pa-3 mb-3 rounded-lg"
              color="#EDF1F0"
              v-for="(item, x) in answered.data_notes_scholar"
              :key="`note-${x}`"
              flat
            >
              <div class="d-flex">
                <v-avatar class="mr-3">
                  <img
                    :src="
                      item.data_user.profile_picture
                        ? item.data_user.profile_picture
                        : ava
                    "
                    class="obj_fit"
                    alt=""
                  />
                </v-avatar>
                <div>
                  <h4>
                    {{
                      item.data_user.name ? item.data_user.name : "Anonymouse"
                    }}
                  </h4>
                  <small class="grey--text">
                    {{ $date(item.created_at).fromNow() }}</small
                  >
                </div>
              </div>
              <div class="px-3 d-flex">
                <div style="margin-right: 46px"></div>
                {{ item.notes }}
              </div>
            </v-card>
            <div
              class="d-flex align-center justify-center flex-column"
              v-if="!answered.data_notes_scholar.length"
            >
              <img
                src="../../../../assets/img/gundam/no_comment.png"
                height="150px"
                alt=""
              />
              <b class="default_txt my-3">No notes yet</b>
            </div>
          </div>
        </v-card>
      </div>
      <div
        v-if="!isReady && !loading"
        class="d-flex flex-column align-center justfiy-center"
      >
        <img
          src="../../../../assets/img/Halaman Unauthorized.png"
          height="300px"
          alt=""
        />
        <h3 class="mt-2">Module not ready</h3>
        <p class="default_txt">
          The module is being prepared by the administrator
        </p>
        <v-btn
          depressed
          dark
          class="mt-2"
          @click="$router.go(-1)"
          :color="section.color"
          >back</v-btn
        >
      </div>

      <div v-if="loading" class="_60_w">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pa-3">
              <v-skeleton-loader
                type="image"
                class="rounded_lg"
                height="230px"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- CREATE QUIZ -->
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchModule"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import DialogMedium from "../../../dialog/dialogMedium.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  components: {
    // DialogMedium,
    DialogSmall,
    vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
    }),
  },
  name: "moduleAssignment",
  data() {
    return {
      loadQuest: false,
      loading: true,
      dataSet: null,
      section: null,
      module: null,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      answered: null,
      materi_id: null,
      score: 50,
      sending: false,

      selected: "",
      notes: "",
      overlay: false,

      // dropzone

      dropzoneOptions: {
        url: "https://httpbin.org/post",
        uploadMultiple: false,
        previewTemplate: this.template(),
      },
      isReady: false,
    };
  },
  mounted() {
    let answer = JSON.parse(localStorage.getItem("answer"));
    if (answer) {
      this.answer = answer;
    }
    this.fetchSection();
    this.fetchModule();
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.section = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchModule() {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      this.loading = true;
      let data = {
        path: `scholar/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          if (data.detail) {
            this.module = data.data;
            this.dataSet = data.detail;
            this.answered = data.jawaban;
            this.isReady = true;
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    fetchData() {
      this.loadQuest = true;
      let data = {
        path: `scholar/course/section/module/material/${this.materi_id}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadQuest = false;
        });
    },
    uploadFile(e) {
      this.overlay = true;
      let section = this.$route.params.idSection;
      let instance = this.$route.params.idInstance;
      let file = new FormData();
      file.append("data_upload", e);
      file.append("course_section_id", section);
      file.append("course_assignment_id", instance);

      let data = {
        path: `scholar/course/section/module/assignment/post`,
        body: file,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.overlay = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.fetchModule();
          this.$refs.myVueDropzone.removeAllFiles();
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.overlay = false;
          this.$refs.myVueDropzone.removeAllFiles();
        });
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-details" style="display:none;">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress" style="display:none;"><span class="dz-upload" data-dz-uploadprogress></span></div>
            </div>
        `;
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.strip_ {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}

#dropzone {
  display: flex;
  justify-content: center;
  border-radius: 10px;
  color: #777;
  border: 1px dashed;
  transition: background-color 0.2s linear;
  min-height: 200px;
  width: 100%;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #59919e;
}
.primary-color {
  color: #59919e;
}
.subtitle {
  color: #314b5f;
}
#dropzone .dz-preview {
  display: none;
  overflow: hidden;
}

.temp_dz {
  background: white !important;
  padding: 10px !important;
  border-radius: 20px !important;
  -webkit-box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
  -moz-box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
  box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
}
</style>
